var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33268 5.85315V6.96426C7.33268 7.18649 7.18453 7.33464 6.96231 7.33464H1.03639C0.814164 7.33464 0.666016 7.18649 0.666016 6.96426V1.03834C0.666016 0.816117 0.814164 0.667969 1.03639 0.667969H2.1475M3.99935 4.0013L6.96231 1.03834M4.36972 0.667969H6.96231C7.18453 0.667969 7.33268 0.816117 7.33268 1.03834V3.63093",
    stroke: "#89B4FA",
    strokeWidth: 0.888889,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableClick);
export default __webpack_public_path__ + "static/media/table-click.2d8aac5156dcf7bc576f94df71f26c70.svg";
export { ForwardRef as ReactComponent };